import { X, CheckCircle, XCircle, AlertCircle } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose }) => (
  <div style={{
    position: 'fixed', top: 20, right: 20, zIndex: 9999,
    padding: '12px 20px', borderRadius: 10,
    background: type === 'success' ? '#10B981' : type === 'error' ? '#EF4444' : '#3B82F6',
    color: '#fff', fontSize: 14, fontWeight: 500,
    display: 'flex', alignItems: 'center', gap: 10,
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)', animation: 'slideIn 0.3s ease-out',
  }}>
    {type === 'success' ? <CheckCircle size={16} /> : type === 'error' ? <XCircle size={16} /> : <AlertCircle size={16} />}
    {message}
    <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', marginLeft: 8 }}>
      <X size={14} />
    </button>
  </div>
);

export default Toast;
